import React from 'react';
import { Sparkles } from 'lucide-react';
import { PersistedWorkflow } from '@cotera/sdk/core';
import { Text } from '@cotera/client/app/components/ui';
import type { WorkflowNodeRenderStrategy } from '../types';
import { asRecord, readString } from '../../utils';

const { WorkflowNodeType } = PersistedWorkflow;

export const adHocAgentNodeStrategy: WorkflowNodeRenderStrategy = {
  nodeType: WorkflowNodeType.AdHocAgent,
  accent: 'agent',
  badge: 'Agent',
  getTitle: () => 'Ad hoc agent',
  getDescription: (node) => readString(asRecord(node.data), 'model'),
  renderIcon: () => <Sparkles className="h-4 w-4" />,
  renderBody: (node) => {
    const record = asRecord(node.data);
    const model = readString(record, 'model');
    const mode = readString(record, 'mode');
    return (
      <div className="space-y-1">
        {model !== undefined ? (
          <Text.Caption className="text-muted-foreground block truncate">
            Model: {model}
          </Text.Caption>
        ) : null}
        {mode !== undefined ? (
          <Text.Caption className="text-muted-foreground block">
            Mode: {mode}
          </Text.Caption>
        ) : null}
      </div>
    );
  },
};
